import React from 'react';

import ProductHeader from '../../../product/components/product-header';
import HeaderCart from '../../../page/components/header-footer/header-cart';
import { useIsPrivateStore } from '../../../hooks/useUserData';

import './sticky-tab.less';

export default ({ tabProps = {} }) => {
    const { HeaderComponent, ...restProps } = tabProps;
    const isPrivateStore = useIsPrivateStore();
    const variation = !isPrivateStore ? 'digit' : '';
    return (
        <div className={`sticky-tab-container ${variation === 'digit' ? 'digitnav' : ''}`}>
            {HeaderComponent ? (
                <HeaderComponent {...restProps} />
            ) : (
                <ProductHeader className="sticky-tabs-nav" {...restProps} tabsListProps={{ dropdownOnMobile: true }} />
            )}
            <div className="cart-menu">
                <HeaderCart
                    enableHeaderState={false}
                    variation={variation}
                    className={`${variation === 'digit' ? 'cart cart-button' : ''}`}
                />
            </div>
        </div>
    );
};
